import { render, staticRenderFns } from "./WpsViewer.vue?vue&type=template&id=05820a92"
import script from "./WpsViewer.vue?vue&type=script&lang=js"
export * from "./WpsViewer.vue?vue&type=script&lang=js"
import style0 from "./WpsViewer.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports